 import team from './images/team (3).jpeg'
 import { LazyLoadImage } from 'react-lazy-load-image-component';
 export default function Aboutus(){
    return(
<div className=" px-10 py-10 md:px-24 py-28 flex flex-col md:flex-row gap-8 md:gap-12  bg-white">
        {/* Right div - العنوان */}
        <div className="md:w-1/2 w-full flex justify-center md:block">
            <LazyLoadImage src={team} alt="Team" className='rounded-2xl max-w-xs md:max-w-md h-auto '/>
        </div>
  
        {/* Left div - الأسئلة */}
        <div className="md:w-1/2 w-full flex flex-col justify-center ">
        <h2 className=" font-semibold text-teal-custom-DarkCayan text-3xl text-center md:text-right">
        إحنا مين؟ 
          </h2>
          <p className='  text-base text-gray-700 font-medium py-10 leading-8 text-center md:text-right'>
          إحنا مجموعة من أطباء الأسنان بجامعة الإسكندرية هدفنا نكون أصحابك ودليلك في كل اللي مُمكن يرشدك لصحتك وأكلك وأثرهم على أسنانك، عملنالك عالم مليئ بالاستكشافات فيه كل اللي ممكن تحتاجه عشان تاخد المعلومة بالطريقة اللي تحبها.. 
جاهز تستكشف عالمنا؟
          </p>
        
        </div>
      </div>
    );
}